
import { defineComponent } from "vue";
import Competition from "../components/Competition.vue";
export default defineComponent({
  name: "HomeComponent",
  components: {
    Competition,
  },
});
